// default to 8km, ~5mi radius
export const defaultSearchRadiusMeters = 8000;
